module.exports = __webpack_public_path__ + "img/phone.b17f86c4.svg";